module.exports = __webpack_public_path__ + "static/media/aad99a1f-7917-4dd6-bbb5-b07cedbff64f.d42bfc91.woff2";